import ResponsiveTableFactory from '../libs/ResponsiveTable';
import UiHelper from './modules/UiHelper';
import PrimaryNav from './modules/PrimaryNav';
import HeaderSearch from './modules/HeaderSearch';
import OffcanvasSidebar from './modules/OffcanvasSidebar';
import FormFactory from './modules/Form';
import LogoSliderFactory from './modules/LogoSlider';
import NewsletterForms from './modules/NewsletterForms';
import Tags from './modules/Tags';
import ImageSliderFactory from './modules/ImageSlider';
import OverlaySliderFactory from './modules/OverlaySlider';
import LocationMapFactory from './modules/LocationMap';
import ExpandBlockFactory from './modules/ExpandBlock';
import CommentForm from './modules/CommentForm';
import HeroSliderFactory from './modules/HeroSLider';
import ColcadeMasonry from './modules/ColcadeMasonry';

/**
 * Kickstarts JS on document ready event
 */
function onDocumentReady()
{
	UiHelper.init();
	PrimaryNav.init();
	HeaderSearch.init();
	FormFactory.init();
	LogoSliderFactory.init();
	NewsletterForms.init();
	OffcanvasSidebar.init();
	Tags.init(); //via UiHelper !
	ImageSliderFactory.init();
	OverlaySliderFactory.init();
	LocationMapFactory.init();
	ResponsiveTableFactory.init('.post-content table');
	ExpandBlockFactory.init();
	CommentForm.init();
	HeroSliderFactory.init();
	ColcadeMasonry.init();
}

//call onDocumentReady()
if (document.readyState != 'loading') onDocumentReady();
else document.addEventListener('DOMContentLoaded', onDocumentReady);


